import { defaultPrdInspectResultDto, PrdInspectResultDto } from "src/dtos/prdInspectResult/prdInspectResultDto";
import { defaultProductResultDto, ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { defaultWmsStockLotDto, WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { defaultTqcWorkStandardDto, TqcWorkStandardDto } from "src/dtos/tqcWorkStandard/tqcWorkStandardDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface KSK2140_R01HeaderDto extends ProductResultDto {
	/** wms_transport_lot.lot_no — LOT 번호 */
	lotNo: string;
	/** LOT 재고량 */
	lotQty: number;
	/** 실적량 */
	processLotQty: number;
	packQty: number;
}

/** Info + Header 병합 — 검사 Info 필드와 생산실적 Header 필드 호환 */
export interface KSK2140_R01InfoDto extends KSK2140_R01HeaderDto {
	inspectDt: string | undefined;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
	labelPrintAuto: "Y" | "N";
	/** 불량수량 */
	inspectQty: number;
}

export interface KSK2140_R01Dto {
	productResultHeaderDto: KSK2140_R01InfoDto;
	productResultDetailList: KSK2140_R01DetailDto[];
	prdInspectResultDtoList: Record<string, KSK2140_R01InspectDto[]>;
	wmsStockLotDtoList: KSK2140_R01LotDto[];
}

export interface KSK2140_R01DetailDto extends PrdInspectResultDto {
	/** 품명 (조인/표시용) */
	itemNm: string;
	/** 포장량 — 기본값 0 */
	packQty: number;
	/** LOT 재고량 */
	lotQty: number;
	lotCreateDt: string;
	/** 실적량 */
	processLotQty: number;
	/** 검사여부 — Y: 검사완료, N: 미검사 */
	checkFinish: "Y" | "N";
}

export interface KSK2140_R01LotDto extends WmsStockLotDto {}

export interface KSK2140_R01InspectDto extends PrdInspectResultDto {}

export interface KSK2140_R01WorkStandardDto extends TqcWorkStandardDto {}

export const defaultKSK2140_R01WorkStandardDto: KSK2140_R01WorkStandardDto = {
	...defaultTqcWorkStandardDto,
};

/** 상세 행별 검사 목록 — key = `${basOrderNo}_${lotNo}` */
export type KSK2140_R01InspectMap = Record<string, KSK2140_R01InspectDto[]>;

export const defaultKSK2140_R01HeaderDto: KSK2140_R01HeaderDto = {
	...defaultProductResultDto,
	lotNo: "",
	lotQty: 0,
	processLotQty: 0,
	packQty: 0,
};

export const defaultKSK2140_R01DetailDto: KSK2140_R01DetailDto = {
	...defaultPrdInspectResultDto,
	itemNm: "",
	packQty: 0,
	lotQty: 0,
	lotCreateDt: "",
	processLotQty: 0,
	checkFinish: "N",
};

export const defaultKSK2140_R01InfoDto: KSK2140_R01InfoDto = {
	...defaultKSK2140_R01HeaderDto,
	inspectDt: formatDate(new Date()),
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	labelPrintAuto: "N",
	inspectQty: 0,
};

export const defaultKSK2140_R01LotDto: KSK2140_R01LotDto = {
	...defaultWmsStockLotDto,
};

export const defaultKSK2140_R01InspectDto: KSK2140_R01InspectDto = {
	...defaultPrdInspectResultDto,
};

export const defaultKSK2140_R01Dto: KSK2140_R01Dto = {
	productResultHeaderDto: defaultKSK2140_R01InfoDto,
	productResultDetailList: [],
	prdInspectResultDtoList: {},
	wmsStockLotDtoList: [],
};
